<style lang="less" scoped>
.el-menu{position: fixed;bottom: 0;left: 0;width: 220px;overflow-y: auto;background-color: #2b4063!important;&::-webkit-scrollbar {display: none;}}
.view{overflow-y: auto;&::-webkit-scrollbar {display: none;}}
.ht{position:relative;}
.banner{position: relative;margin-left:240px;top:0px;padding-top:10px;height: 40px; color:rgb(95, 95, 95);font-size: 15px;border-bottom: 1px solid #dbd9d9;box-shadow: 0px 0px 3px 2px rgb(218, 216, 216);}
.left,.right{position: absolute;}
.left{left:0;margin-left: 20px;}
.right{right:0;margin-right: 20px;}
.right{right: 0;}
.out:hover{color:#0a82f3;}
.box {height: 100%;}
.uppsd{font-weight: 600;cursor: pointer;margin-left: 20px;}
.efrom{margin-left: 200px;}
.uptd{padding-top: 17px;width: 200px;}
</style>

<template>
  <div class="ht">
    <div class="banner">
      <div class="left">
        <span style="font-size: 22px; font-weight: bold;color: #000000;">中国-东盟矿业信息服务平台后台管理</span>
      </div>
      <div class="right">
        <span style="margin-left: 10px;">南宁：{{weather}}&nbsp;&nbsp;{{lower}}~{{higher}}</span>&nbsp;
        <span class="uppsd" @click="uppsd">修改密码</span>
        <span class="out" style="cursor: pointer;margin-left: 20px;font-weight: 600;" @click="out">退出</span>
      </div>
    </div>

    <div class="box">
      <div v-wechat-title="$route.meta.title"></div>
      <el-menu
        text-color="#fff"
        :default-active="activeIndex"
        router
        exact
        style="min-height: 100vh; width: 240px; float: left;"
        :unique-opened="true">
        <NavMenu :navMenus="menuData"></NavMenu>
      </el-menu>
    </div>

    <router-view class="view" style="margin-left:240px;"></router-view>

    <div>
      <el-dialog title="用户修改密码" :visible.sync="dialogFormVisible">
        <el-form class="efrom" :model="form">
          <table>
            <tr>
              <td>旧密码</td>
              <td class="uptd">
                <el-form-item>
                  <el-input type="password" v-model="form.ordPsd" @blur="selectps"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>新密码</td>
              <td class="uptd">
                <el-form-item>
                  <el-input type="password" v-model="form.newPsd"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td>确认密码</td>
              <td class="uptd">
                <el-form-item>
                  <el-input type="password" v-model="form.repeatPsd"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
        <div>
          <el-button type="success" @click="updatepwd">修改</el-button>
          <el-button @click="cancelfn()">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 后台整体结构布局
 */
import NavMenu from '../layout/NavMenu.vue'
import ScaleBox from '../../app/assembly/ScaleBox.vue'
export default {
  components: {
    NavMenu,
    ScaleBox
  },
  data()
  {
    return {
      form: {
        ordPsd: '',
        newPsd: '',
        repeatPsd: ''
      },
      activeIndex: 'HTIndex',
      menuData: [],
      roleid: '',
      roleValue: [],
      admin: '',
      weather: null,
      lower: null,
      higher: null,
      dialogFormVisible: false
    }
  },
  created()
  {
    this.getTree()
    // this.getWeather()
    this.admin = JSON.parse(localStorage.getItem('userMsg')).username
  },
  methods: {
    getTree()
    {
      this.roleValue = []
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let userRole = userInfo.role.toString()
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 18,
        _exp: `roleid in (${userRole})`
      }
      window.post.getPost(paras).then((ret1) =>
      {
        ret1.forEach(item => this.roleValue.push(item))
        let exp = ''
        let data = this.roleValue.map(item => item.objectid)
        let newData = Array.from(new Set(data))
        if (this.roleValue.length === 0 && userInfo.userid === 1)
          exp = 'id > 0'
        else
          exp = `id in (${newData})`
        let paras1 = {
          cmd: 'query',
          _major: 99,
          _minor: 19,
          _exp: exp
        }
        window.post.getPost(paras1).then((ret) =>
        {
          this.menuData = this.toTree(ret, 'id', 'glid')
        })
      })
    },
    toTree(data, code, ParentCode)
    {
      let result = []
      if (!Array.isArray(data))
      {
        //判断是否数组不是结束掉
        return result
      }
      data = data.map((item) =>
      {
        return {
          entity: { ...item }
        }
      })
      let map = {} //定义一个对象
      data.forEach((item) =>
      {
        //循环数组 把每一项都丢进对象里
        map[item['entity'][code]] = item
      })
      data.forEach((item) =>
      {
        //循环数组 定义父级 找数组当前项的父级 如果有那么将当前项添加到对象父级里
        let parent = map[item['entity'][ParentCode]]
        if (parent)
          (parent.childs || (parent.childs = [])).push(item)
        else
          result.push(item)
      })
      return result
    },
    // 获取天气
    getWeather()
    {
      fetch('http://wthrcdn.etouch.cn/weather_mini?city=南宁')
        .then(res => res.json())
        .then(res =>
        {
          this.weather = res.data.forecast[0].type ? res.data.forecast[0].type : ''
          this.lower = res.data.forecast[0].low.substr(2)
          this.higher = res.data.forecast[0].high.substr(2)
        })
    },
    // 退出
    out()
    {
      this.$router.push({path: '/loginHT'})
      localStorage.clear()
      sessionStorage.clear()
    },
    uppsd()
    {
      this.dialogFormVisible = true
    },
    cancelfn()
    {
      this.dialogFormVisible = false
    },
    updatepwd()
    {
      let upuserId = JSON.parse(localStorage.getItem('userMsg')).userid
      if (this.form.ordPsd === this.form.newPsd)
        this.$message({message: '旧密码和新密码设置不能相同', type: 'error'})
      if (this.form.newPsd !== this.form.repeatPsd)
        this.$message({message: '两次密码输入不一样', type: 'error'})
      let paras = {cmd: 'setPsw', oldpassword: this.form.ordPsd, newpassword: this.form.newPsd, _userId: `${upuserId}`, _sys: 11}
      window.post.getLogin(paras).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败，请检查原密码是否正确', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success'})
          this.clear()
          this.dialogFormVisible = false
        }
      })
    },
    clear()
    {
      this.form.ordPsd = this.form.newPsd = this.form.repeatPsd = ''
    },
    selectps()
    {
      let upuserId = JSON.parse(localStorage.getItem('userMsg')).userid
      let paras = {cmd: 'query', _major: 99, _minor: 14, _exp: `id = ${upuserId}`}
      window.post.getPost(paras).then((ret) =>
      {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/layout/MenuRight.vue